import React from 'react';
import { Row, Col } from 'antd';
import './PegBoardHighlight.css';

import laptopMockup from '../../../assets/laptop-mockup.png';
import laptopMockupMobile from '../../../assets/laptop-mockup-mobile.png';
import ArrowButton from '../../../shared/ArrowButton';
import {
  useNavigate,
} from "react-router-dom";

const PegBoardHighlight = ({ children, gutters, classname, style  }) => { 
  const navigate = useNavigate();
  return <Row
    align="middle"
    gutter={gutters ? gutters : {
      xs: [0, 24],
      xl: [0, 48],
    }}
    className="pegboard-highlight-container"
  >
    <Col xs={24} sm={12} className="pegboard-highlight-left">
      <picture className="pegboard-picture">
        <source
          media="(max-width: 1199px)"
          srcSet={laptopMockupMobile}
        />
        <img
          src={laptopMockup}
          alt="Digital Peg Board on laptop"
          className="pegboard-highlight-image"
        />
      </picture>
    </Col>

    <Col xs={24} sm={12} className={ classname ? classname : "pegboard-highlight-right" } style={{ ...style }}>
      { children && <>{ children }</> }
      { !children && <>
        <h2 className="pegboard-highlight-title">
          Digital Peg Board
        </h2>

        <p className="pegboard-highlight-description">
          Revolutionise your club sessions with our Digital Peg Board,
          an innovative feature that automates court assignments,
          ensuring every player gets fair and balanced game time.
        </p>

        <ArrowButton 
          variant="white" 
          className="pegboard-highlight-button"
          onClick={() => { 
            navigate("/pegboard")
            document.getElementById('root').scrollTo(0, 0);
          }}
          >
          Discover the Digital Peg Board
        </ArrowButton>
      </>}
    </Col>
  </Row>
};

export default PegBoardHighlight;
